import axios from "axios";
import { getHeaders } from "../utils/helpers/main";
import endpoints from "./endpoints";

export const searchCustomerDetaislUsingPhoneApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.customerSearchByPhone,
    method: "GET",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const getCustomerSuggetionListApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.customerSuggestionPhone,
    method: "GET",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};
